import { defineMessages } from 'react-intl'

const scope = `procurify.platform.banking.presenter.CreateExternalPaymentMethodFormPresenter`

export default defineMessages({
  paymentMethodCreatedSuccessToast: {
    id: `${scope}.paymentMethodCreatedSuccessToast`,
    defaultMessage: 'Payment method created',
  },
  createPaymentMethodErrorToast: {
    id: `${scope}.createPaymentMethodErrorToast`,
    defaultMessage: 'Payment method not created',
  },
})
